export default {
  path: "/HighlightedTopic/CommercialMotorVehicles",
  name: "Highlighted Topic - Commercial Motor Vehicles",
  type: "highlightedTopic",
  htmlContent: "HT-CommercialMotorVehicles.html",
  keyPoints: [
    "Every vehicle involved in a crash must have <u>Vehicle Type</u> and a <u>Vehicle Class</u> identified. The <i>Commercial Motor Vehicle</i> portion of the crash report must be completed in its entirety if the identified <u>Vehicle Type</u> is one of the following:  <ul><li>Tractor Trailer (Bobtail) </li><li>Tractor / Trailer </li><li>Tractor w / Twin Trailers </li><li>Logging Truck </li><li>Logging Tractor / Trailer </li><li>Single Unit Truck </li><li>Panel Truck </li><li>Bus </li><li>Truck Towing House Trailer </li><li>Ambulance (Only if it meets CMV requirements; does not include four wheeled medical service vehicles – see <a href='/SectionContent/CommercialMotorVehicles'>Commercial Motor Vehicles</a> Section)</ul>",
  ],
  scenarios: [
    {
      name: "Detailed Diagram",
      image: "https://crashmanual.s3.us-east-2.amazonaws.com/HotTopics/CMV.png",
    },
  ],
  keywords: [
    "commercial",
    "tractor",
    "trailer",
    "CMV",
    "log",
    "truck",
    "tow",
    "vehicle class",
    "vehicle type",
    "gross",
  ],
};
